export default {
  titles: {
    default: 'Muistutus ajastetusta tilauksesta!',
    external_delivery: 'Kuljettaja määritetty!',
  },
  labels: {
    pickup: 'Nouto: {{time}}',
    serve: 'Tarjoilu: {{time}}',
    preparation_time: 'Valmisteluaika: {{time}} min',
  },
  buttons: {
    confirm: 'Aloita valmistus nyt',
    print_and_confirm: 'Tulosta ja aloita valmistus nyt',
  },
  toasts: {
    something_went_wrong: 'Jokin meni pieleen, yritä uudelleen',
  },
};
